export const SHIPPING_LABEL: any = {
    'United States': {
      shipToName: 'Ship to Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      address: 'Address',
      addressTC: 'Street Address',
      addressConfirm: 'Address 2',
      addressConfirmTC: 'Apartment, suite, unit, etc. (optional)',
      city: 'City',
      zip: 'ZIP/Postal Code',
      zipTC: 'Zip Code',
      country: 'Country',
      state: 'State',
      stateLabel: 'Choose a State'
    },
    'Australia': {
      state: 'State/Territory',
      stateLabel: 'Choose a State/Territory',
    },
    'Canada': {
      state: 'Province/Territory',
      stateLabel: 'Choose a Province/Territory',
    },
    'United Kingdom': {
      state: 'County/Region',
      stateLabel: 'Choose a County/Region',
    },
    'Germany': {
      shipToName: 'Empfängername',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'Stadt',
      zip: 'Postleitzahl',
      country: 'Land',
      state: 'Zustand',
      stateLabel: 'Wählen Sie einen Staat',
      'United States': 'Vereinigte Staaten',
      'United Kingdom': 'Großbritannien',
      'Canada': 'Kanada',
      'Australia': 'Australien',
      'Argentina': 'Argentinien',
      'Chile': 'Chile',
      'Colombia': 'Kolumbien',
      'Denmark': 'Dänemark',
      'France': 'Frankreich',
      'Germany': 'Deutschland',
      'Mexico': 'Mexiko',
      'New Zeland': 'Neuseeland',
      'Peru': 'Peru',
      'Puerto Rico': 'Puerto Rico',
      'Singapore': 'Singapur',
      'Spain': 'Spanien',
      'Virgin Islands, British': 'Virgin Inseln, Britisch',
    },
    'Mexico': {
      shipToName: 'Nombre de envío',
      address: 'Dirección',
      addressConfirm: 'Dirección 2',
      city: 'Ciudad',
      zip: 'Código postal',
      country: 'País',
      state: 'Estado',
      stateLabel: 'Elige un estado'
    },
    'Russia': {
      shipToName: 'Имя получателя',
      address: 'Адрес',
      addressConfirm: 'Адрес 2',
      city: 'Город',
      zip: 'Почтовый индекс',
      country: 'Страна',
      state: 'Область',
      stateLabel: 'Выберите область'
    },
    'China': {
      shipToName: '收件人姓名',
      address: '地址',
      addressConfirm: '地址 2',
      city: '市',
      zip: '邮政编码',
      country: '国家',
      state: '州',
      stateLabel: '选择一个州'
    },
    'Greece': {
      shipToName: 'Όνομα παραλήπτη',
      address: 'Διεύθυνση ',
      addressConfirm: 'Διεύθυνση 2',
      city: 'Πόλη',
      zip: 'Ταχυδρομικός κώδικας',
      country: 'Χώρα',
      state: 'Πολιτεία',
      stateLabel: 'Επιλέξτε μια κατάσταση'
    },
    'Austria': {
      shipToName: 'Name des Empfängers',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'Stadt',
      zip: 'Postleitzahl',
      country: 'Land',
      state: 'Zustand',
      stateLabel: 'Wählen Sie einen Staat'
    },
    'Belgium': {
      shipToName: 'Nom du destinataire',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'Ville',
      zip: 'Code postal',
      country: 'Pays',
      state: 'État',
      stateLabel: 'Choisissez un état'
    },
    'Bulgaria': {
      shipToName: 'Име на получателя',
      address: 'Адрес',
      addressConfirm: 'Адрес 2',
      city: 'Град',
      zip: 'Пощенски код',
      country: 'Страна',
      state: 'Област',
      stateLabel: 'Изберете област'
    },
    'Croatia': {
      shipToName: 'Ime primatelja',
      address: 'Adresa',
      addressConfirm: 'Adresa 2',
      city: 'Grad',
      zip: 'Poštanski broj',
      country: 'Zemlja',
      state: 'Država',
      stateLabel: 'Odaberite državu'
    },
    'Cyprus': {
      shipToName: 'Όνομα παραλήπτη',
      address: 'Διεύθυνση ',
      addressConfirm: 'Διεύθυνση 2',
      city: 'Πόλη',
      zip: 'Ταχυδρομικός κώδικας',
      country: 'Χώρα',
      state: 'Πολιτεία',
      stateLabel: 'Επιλέξτε μια κατάσταση'
    },
    'Czech Republic': {
      shipToName: 'Jméno příjemce',
      address: 'Adresa',
      addressConfirm: 'Adresa 2',
      city: 'Město',
      zip: 'PSČ',
      country: 'Země',
      state: 'Stát',
      stateLabel: 'Vyberte stát'
    },
    'Denmark': {
      shipToName: 'Modtagernavn',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'By',
      zip: 'Postnummer',
      country: 'Land',
      state: 'Stat',
      stateLabel: 'Vælg en stat'
    },
    'Estonia': {
      shipToName: 'Saaja nimi',
      address: 'Aadress',
      addressConfirm: 'Aadress 2',
      city: 'Linn',
      zip: 'Postiindeks',
      country: 'Riik',
      state: 'Osariik',
      stateLabel: 'Valige osariik'
    },
    'Finland': {
      shipToName: 'Vastaanottajan nimi',
      address: 'Osoite',
      addressConfirm: 'Osoite 2',
      city: 'Kaupunki',
      zip: 'Postinumero',
      country: 'Maa',
      state: 'Osavaltio',
      stateLabel: 'Valitse osavaltio'
    },
    'France': {
      shipToName: 'Nom du destinataire',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'Ville',
      zip: 'Code postal',
      country: 'Pays',
      state: 'État',
      stateLabel: 'Choisissez un état'
    },
    'Hungary': {
      shipToName: 'Címzett neve',
      address: 'Cím',
      addressConfirm: 'Cím 2',
      city: 'Város',
      zip: 'Irányítószám',
      country: 'Ország',
      state: 'Állam',
      stateLabel: 'Válassz államot'
    },
    'Italy': {
      shipToName: 'Nome del destinatario',
      address: 'Indirizzo',
      addressConfirm: 'Indirizzo 2',
      city: 'Città',
      zip: 'CAP',
      country: 'Paese',
      state: 'Stato',
      stateLabel: 'Scegli uno stato'
    },
    'Latvia': {
      shipToName: 'Saņēmēja vārds',
      address: 'Adrese',
      addressConfirm: 'Adrese 2',
      city: 'Pilsēta',
      zip: 'Pasta indekss',
      country: 'Valsts',
      state: 'Valsts',
      stateLabel: 'Izvēlieties valsti'
    },
    'Lithuania': {
      shipToName: 'Gavėjo vardas',
      address: 'Adresas',
      addressConfirm: 'Adresas 2',
      city: 'Miestas',
      zip: 'Pašto kodas',
      country: 'Šalis',
      state: 'Valstybė',
      stateLabel: 'Pasirinkite valstiją'
    },
    'Luxembourg': {
      shipToName: 'Nom du destinataire',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'Ville',
      zip: 'Code postal',
      country: 'Pays',
      state: 'État',
      stateLabel: 'Choisissez un état'
    },
    'Malta': {
      shipToName: 'Isem tal-Ġwanni',
      address: 'Indirizz',
      addressConfirm: 'Indirizz 2',
      city: 'Belt',
      zip: 'Kodiċi Postali',
      country: 'Pajjiż',
      state: 'Stat',
      stateLabel: 'Agħżel stat'
    },
    'The Netherlands': {
      shipToName: 'Naam ontvanger',
      address: 'Adres',
      addressConfirm: 'Adres 2',
      city: 'Stad',
      zip: 'Postcode',
      country: 'Land',
      state: 'Staat',
      stateLabel: 'Kies een staat'
    },
    'Poland': {
      shipToName: 'Nazwa odbiorcy',
      address: 'Adres',
      addressConfirm: 'Adres 2',
      city: 'Miasto',
      zip: 'Kod pocztowy',
      country: 'Kraj',
      state: 'Stan',
      stateLabel: 'Wybierz stan'
    },
    'Portugal': {
      shipToName: 'Nome do destinatário',
      address: 'Endereço',
      addressConfirm: 'Endereço 2',
      city: 'Cidade',
      zip: 'Código postal',
      country: 'País',
      state: 'Estado',
      stateLabel: 'Escolha um estado'
    },
    'Romania': {
      shipToName: 'Numele destinatarului',
      address: 'Adresa',
      addressConfirm: 'Adresa 2',
      city: 'Oraș',
      zip: 'Cod poștal',
      country: 'Țară',
      state: 'Stat',
      stateLabel: 'Alegeți un stat'
    },
    'Slovakia': {
      shipToName: 'Meno príjemcu',
      address: 'Adresa',
      addressConfirm: 'Adresa 2',
      city: 'Mesto',
      zip: 'PSČ',
      country: 'Krajina',
      state: 'Štát',
      stateLabel: 'Vyberte štát'
    },
    'Slovenia': {
      shipToName: 'Ime prejemnika',
      address: 'Naslov',
      addressConfirm: 'Naslov 2',
      city: 'Mesto',
      zip: 'Poštna številka',
      country: 'Država',
      state: 'Država',
      stateLabel: 'Izberite državo'
    },
    'Spain': {
      shipToName: 'Nombre del destinatario',
      address: 'Dirección',
      addressConfirm: 'Dirección 2',
      city: 'Ciudad',
      zip: 'Código postal',
      country: 'País',
      state: 'Estado',
      stateLabel: 'Elige un estado'
    },
    'Sweden': {
      shipToName: 'Namn på mottagaren',
      address: 'Adress',
      addressConfirm: 'Adress 2',
      city: 'Stad',
      zip: 'Postnummer',
      country: 'Land',
      state: 'Stat',
      stateLabel: 'Välj en stat'
    },
    'Japan': {
      shipToName: '受信者名',
      address: '住所',
      addressConfirm: '住所 2',
      city: '市',
      zip: '郵便番号',
      country: '国',
      state: '州',
      stateLabel: '州を選択'
    },
    'Switzerland': {
      shipToName: 'Name des Empfängers',
      address: 'Adresse',
      addressConfirm: 'Adresse 2',
      city: 'Stadt',
      zip: 'Postleitzahl',
      country: 'Land',
      state: 'Zustand',
      stateLabel: 'Wählen Sie einen Staat'
    },
    'Hong Kong': {
      shipToName: '收件人姓名',
      address: '地址',
      addressConfirm: '地址 2',
      city: '市',
      zip: '郵政編碼',
      country: '國家',
      state: '州',
      stateLabel: '選擇一個州'
    },
    'Taiwan': {
      shipToName: '收件人姓名',
      address: '地址',
      addressConfirm: '地址 2',
      city: '市',
      zip: '郵政編碼',
      country: '國家',
      state: '州',
      stateLabel: '選擇一個州'
    },
    'Iceland': {
      shipToName: 'Nafn móttakanda',
      address: 'Heimilisfang',
      addressConfirm: 'Heimilisfang 2',
      city: 'Borg',
      zip: 'Póstnúmer',
      country: 'Land',
      state: 'Ríki',
      stateLabel: 'Veldu ríki'
    },
    'Brazil': {
      shipToName: 'Nome do destinatário',
      address: 'Endereço',
      addressConfirm: 'Endereço 2',
      city: 'Cidade',
      zip: 'Código postal',
      country: 'País',
      state: 'Estado',
      stateLabel: 'Escolha um estado'
    },
  
  }